<div class="w-full max-w-6xl m-8 bg-white">
    <div class="flex-auto">
        <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b">
            <div>
                <div class="text-4xl font-extrabold tracking-tight leading-none">
                    @if (stateListGroups) {
                        {{ 'label_registered_group' | translatePlural }}
                    }
                    @if (stateAddGroup) {
                        {{ 'label_add_group' | translate }}
                    }
                    @if (stateEditGroup) {
                        {{ 'label_edit_group' | translate }}
                    }
                    @if (stateViewOnly) {
                        {{ 'label_view_group' | translate }}
                    }
                    @if (!stateListGroups) {
                        <mat-icon
                            [matTooltip]="'label_close' | translate"
                            (click)="cancelGroup()"
                            id="c-close"
                            class="icon-size-8 hover:cursor-pointer float-right"
                            svgIcon="heroicons_outline:x"
                        ></mat-icon>
                    }
                </div>
                @if (stateListGroups) {
                    <div class="ml-0.5 font-medium text-secondary">
                        {{ 'label_group_count' | translate: { count: groupsCount } }}
                    </div>
                }
            </div>
            @if (stateListGroups) {
                <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                    <div class="flex-auto">
                        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                            <input matInput [formControl]="searchInputControl" autocomplete="'off'" [placeholder]="'Leita að hópi'" />
                        </mat-form-field>
                    </div>
                    <button class="ml-4" mat-flat-button [color]="'primary'" (click)="addGroup()">
                        <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                        <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
                    </button>
                </div>
            }
        </div>
        @if (stateListGroups) {
            <div class="relative">
                @if (userDetails && groups) {
                    @if (searchedGroups?.length) {
                        @for (group of searchedGroups; track $index; let i = $index) {
                            @if (i === 0 || group.name.charAt(0).toUpperCase() !== searchedGroups[i - 1].name.charAt(0).toUpperCase()) {
                                <div
                                    class="z-10 sticky top-0 -mt-px px-6 py-1 md:px-8 border-t border-b font-medium uppercase text-secondary bg-gray-50 dark:bg-gray-900"
                                >
                                    {{ group.name.charAt(0) }}
                                </div>
                            }
                            <span class="z-20 flex items-center px-6 py-4 md:pl-8 md:pr-3 overflow-x-hidden border-b">
                                <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full">
                                    <ng-container>
                                        <img class="object-cover w-full h-full" src="/assets/images/groups/group.png" alt="Mynd" />
                                    </ng-container>
                                </div>
                                <div class="w-100 ml-4">
                                    <div class="font-medium leading-5 truncate">
                                        {{ group.name }}
                                    </div>
                                    <div class="flex flex-wrap sm:flex-nowrap">
                                        <span class="flex flex-row grow">
                                            {{ group.description == null ? 'Lýsingu vantar' : group.description }}</span
                                        >
                                        <span class="hidden md:flex shrink gap-2">
                                            <div class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal bg-gray-100">
                                                <span class="text-sm font-medium whitespace-nowrap">
                                                    {{ findGroupTypeName(group) | translate }}
                                                </span>
                                            </div>
                                            @if (group?.groupEntryOwnerUserId) {
                                                <div class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal bg-gray-100">
                                                    <span class="text-sm font-medium whitespace-nowrap">
                                                        {{ 'info_confirm_group_type_your_own' | translate }}
                                                    </span>
                                                </div>
                                            }
                                            @if (group?.svid) {
                                                <div
                                                    class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal text-white bg-gray-100 bg-primary-500"
                                                >
                                                    <span class="text-sm font-medium whitespace-nowrap">
                                                        {{ 'info_confirm_group_type_svid' | translate }}
                                                    </span>
                                                </div>
                                            }
                                            @if (group?.groupEntryOwnerUserId == null && group?.svid == null) {
                                                <div
                                                    class="c-yfirnotandi-tag h-8 py-1 px-3 rounded-full leading-normal text-white bg-gray-100 bg-primary-500"
                                                >
                                                    <span class="text-sm font-medium whitespace-nowrap">
                                                        {{ 'info_confirm_group_type_system' | translate }}
                                                    </span>
                                                </div>
                                            }
                                        </span>
                                    </div>
                                </div>
                                @if (canEditGroup(group)) {
                                    <div class="c-editButtonList">
                                        <button mat-icon-button type="button" (click)="editGroup(group)" [matTooltip]="'Breyta'">
                                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:pencil-alt'"></mat-icon>
                                        </button>
                                    </div>
                                    <button
                                        mat-icon-button
                                        type="button"
                                        (click)="deleteGroup(group.groupId)"
                                        [matTooltip]="'label_delete' | translate"
                                    >
                                        <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                    </button>
                                }
                                @if (!canEditGroup(group)) {
                                    <div class="c-editButtonList">
                                        <button mat-icon-button type="button" (click)="viewGroup(group)" [matTooltip]="'Skoða'">
                                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:eye'"></mat-icon>
                                        </button>
                                    </div>
                                }
                            </span>
                        }
                    }
                }
                @if (hasHttpFetched && searchedUsers?.length == 0) {
                    <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center" #noUsers>
                        {{ 'info_no_group_found' | translatePlural }}
                    </div>
                }
            </div>
        }
        @if ((stateAddGroup || stateEditGroup || stateViewOnly) && form) {
            <div class="relative">
                <form (keydown.enter)="$event.preventDefault()" [formGroup]="form" #singleInNgForm="ngForm">
                    <span class="p-8 float-left w-100">
                        <div class="grid sm:grid-cols-4 gap-6 w-full">
                            <ng-container>
                                @if (!stateViewOnly) {
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="w-full">
                                            <mat-label>{{ 'label_name' | translate }}</mat-label>
                                            <input [formControlName]="'name'" maxlength="80" matInput />
                                        </mat-form-field>
                                    </div>
                                }
                                @if (!stateViewOnly) {
                                    <div class="col-span-4 sm:col-span-2">
                                        <mat-form-field class="w-full">
                                            <mat-label>{{ 'label_type' | translate }}</mat-label>
                                            <mat-select
                                                (selectionChange)="checkGroupType()"
                                                [formControlName]="'groupTypeId'"
                                                placeholder="{{ 'label_type' | translate }}"
                                            >
                                                @for (type of groupTypes; track type.groupTypeId) {
                                                    <mat-option [value]="type.groupTypeId">
                                                        {{ type.name | translate }}
                                                    </mat-option>
                                                }
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                }
                                @if (!stateViewOnly) {
                                    <div class="col-span-4">
                                        <mat-form-field class="w-full">
                                            <mat-label>{{ 'label_description' | translate }}</mat-label>
                                            <textarea [formControlName]="'description'" maxlength="200" matInput> </textarea>
                                            <mat-hint class="ml-auto">
                                                <span
                                                    class="bold"
                                                    [ngClass]="{
                                                        'notification-color': this.form?.get('description')?.value?.length > 200,
                                                    }"
                                                >
                                                    {{ 200 - this.form?.get('description')?.value?.length }}
                                                </span>
                                                {{
                                                    'info_characters_left'
                                                        | translate
                                                            : {
                                                                  count: 200 - this.form?.get('description')?.value?.length,
                                                              }
                                                }}
                                            </mat-hint>
                                        </mat-form-field>
                                        <span class="separator-line float-left w-100"></span>
                                    </div>
                                }
                                @if (!stateViewOnly) {
                                    <div class="col-span-4">
                                        <div class="flex flex-col md:flex-col flex-auto justify-between">
                                            <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                                                <div class="flex-auto">
                                                    <public-registry-search
                                                        label="{{
                                                            (groupFirms
                                                                ? 'label_company'
                                                                : groupPersons
                                                                  ? 'label_person'
                                                                  : groupMixed
                                                                    ? 'label_person_company'
                                                                    : ''
                                                            ) | translate
                                                        }}"
                                                        pluralLabel="{{
                                                            (groupFirms
                                                                ? 'label_company'
                                                                : groupPersons
                                                                  ? 'label_person'
                                                                  : groupMixed
                                                                    ? 'label_person_company'
                                                                    : ''
                                                            )
                                                                | translatePlural
                                                                    : {
                                                                          count: 3,
                                                                      }
                                                        }}"
                                                        [enableBatchInput]="true"
                                                        [disableInput]="form.get('name').invalid || form.get('groupTypeId').invalid"
                                                        [persistSelection]="false"
                                                        (onOptionSelected)="entrySelected($event)"
                                                        (invalidSsns)="handleInvalidSsns($event)"
                                                        [searchForCompanies]="groupFirms || groupMixed"
                                                        [searchForPersons]="groupPersons || groupMixed"
                                                        subtitle="{{ 'info_add_group_person_firm_info' | translate }}"
                                                    >
                                                    </public-registry-search>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                @if (groupCount == 0 && stateViewOnly) {
                                    <div>Þessi hópur er tómur</div>
                                }
                                <div
                                    class="col-span-4"
                                    [ngClass]="{
                                        hidden: groupCount == 0 && totalEntries == 0,
                                    }"
                                >
                                    <div class="flex-auto">
                                        <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                            <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                            @if (stateViewOnly) {
                                                <input matInput [formControl]="filterControl" placeholder="Leita í hópi" />
                                            }
                                            @if (!stateViewOnly) {
                                                <input matInput (keyup)="searchPeople($event.target.value)" placeholder="Leita í hópi" />
                                            }
                                        </mat-form-field>
                                    </div>
                                    <table class="w-full" mat-table [dataSource]="dataSource" matSort>
                                        <ng-container matColumnDef="ssn">
                                            <th class="w-[80%]" mat-sort-header="ssn" mat-header-cell *matHeaderCellDef>
                                                {{
                                                    (groupFirms
                                                        ? 'label_company'
                                                        : groupPersons
                                                          ? 'label_person'
                                                          : groupMixed
                                                            ? 'label_person_company'
                                                            : ''
                                                    )
                                                        | translate
                                                            : {
                                                                  count: totalEntries,
                                                              }
                                                }}
                                            </th>
                                            <td class="w-[80%]" mat-cell *matCellDef="let group" [formGroup]="group">
                                                {{ group.get('name').value + ', kt. ' + group.get('ssn').value }}
                                            </td>
                                        </ng-container>
                                        <ng-container matColumnDef="action">
                                            <th class="w-[20%]" mat-sort-header="action" mat-header-cell *matHeaderCellDef></th>
                                            <td class="w-[20%] text-center" mat-cell *matCellDef="let group; let i = index">
                                                <span>
                                                    @if (!stateViewOnly) {
                                                        <button
                                                            mat-icon-button
                                                            type="button"
                                                            (click)="deleteSSNEntryFormItem(group)"
                                                            [matTooltip]="'label_delete' | translate"
                                                        >
                                                            <mat-icon
                                                                class="icon-size-5 text-current"
                                                                [svgIcon]="'heroicons_solid:trash'"
                                                            ></mat-icon>
                                                        </button>
                                                    }
                                                </span>
                                            </td>
                                        </ng-container>
                                        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
                                        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
                                    </table>
                                    <mat-paginator
                                        #tablePaginator
                                        class="justify-end"
                                        showFirstLastButtons
                                        [pageSize]="pageSize"
                                        [pageSizeOptions]="[5, 10, 25, 50]"
                                        [length]="totalEntries"
                                        (page)="onPageChanged($event)"
                                    >
                                    </mat-paginator>
                                </div>
                                @if (lsrauthService.inRole(userDetails, userRoles.EDIT_SVID_GROUPS) && !stateViewOnly) {
                                    <div class="col-span-4">
                                        <span class="w-full checkbox-compact">
                                            <mat-checkbox class="ml-[10px]" [color]="'primary'" formControlName="svid">
                                                {{ 'info_confirm_group_type_svid' | translate }} </mat-checkbox>
                                            <mat-hint class="float-left">{{ 'info_group_svid_info' | translate }}</mat-hint>
                                        </span>
                                    </div>
                                }
                            </ng-container>
                        </div>
                        @if (!stateViewOnly && form.get('ssnEntries').hasError('typeMismatch')) {
                            <div class="text-warn p-2">
                                {{ this.invalid.length }} meðlimir passa ekki við þessa tegund
                                {{ groupPersons ? 'Einstaklingshópur' : 'Fyrirtækjahópur' }}. Fjarlægðu þá eða breyttu hópategund í
                                {{ groupPersons ? 'fyrirtækjahóp' : 'einstaklingshóp' }}
                                eða blandaðan hóp.
                            </div>
                        }
                        @if (!stateViewOnly) {
                            <div class="flex items-center justify-end mt-[20px]">
                                <button mat-stroked-button type="button" (click)="cancelGroup()" [disabled]="!formEnabled">
                                    {{ 'label_cancel' | translate }}
                                </button>
                                <button
                                    class="ml-4"
                                    (click)="save()"
                                    mat-flat-button
                                    type="submit"
                                    [color]="'primary'"
                                    [disabled]="!formEnabled || totalEntries == 0 || form.get('ssnEntries').hasError('typeMismatch')"
                                >
                                    @if (formEnabled) {
                                        <span>
                                            @if (stateAddGroup) {
                                                {{ 'label_register' | translate }}
                                            }
                                            @if (stateEditGroup) {
                                                {{ 'label_edit_group' | translate }}
                                            }
                                        </span>
                                    }
                                    @if (!formEnabled) {
                                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                                    }
                                </button>
                            </div>
                        }
                    </span>
                </form>
            </div>
        }
    </div>
</div>
